import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const LineItemSchema = z
    .object({
        type: z.string().optional(),
        title: z.string().optional(),
        sku: z.string().optional(),
        description: z.string().optional(),
        quantity: z.number().optional(),
        itemPrice: z.number(),
    })
    .strict();

export class LineItem extends FromSchema(LineItemSchema) {
    type?: string;
    sku?: string;
    title?: string;
    description?: string;
    quantity?: number;
    itemPrice: number;
}
